import { useEffect, useState } from 'react';

export const useTextDirection = () => {
  const [textDirection, setTextDirection] = useState<'ltr' | 'rtl'>(() => {
    // handle SSR
    if (typeof document === 'undefined') {
      return 'ltr';
    }

    return document.documentElement.dir === 'rtl' ? 'rtl' : 'ltr';
  });

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setTextDirection(document.documentElement.dir === 'rtl' ? 'rtl' : 'ltr');
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['dir'],
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return textDirection;
};
